module.exports = __webpack_public_path__ + "static/media/resume.91b61f30.pdf";